import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { LoggerService } from '../../logger.service';
import { AddressModel } from '../../model/address.model';
import { AddressService } from '../address.service';

@Component({
  selector: 'app-address-preview',
  templateUrl: './address-preview.component.html',
  styleUrls: ['./address-preview.component.css']
})
export class AddressPreviewComponent implements OnInit {

  @Input()
  public title: string;

  @Input()
  public type: 'default' | 'primary' | 'warning';

  @Input()
  public address: AddressModel;

  @Output()
  public edit = new EventEmitter<AddressModel>();

  @Output()
  public value = new EventEmitter<AddressModel>();

  public formatted: string[];

  constructor(
    private service: AddressService,
    public logger: LoggerService
  ) {
  }

  ngOnInit() {
    const match = /\{([\w_]+)\}/g;

    this.service.GetFormat(this.address.adr_country).subscribe(result => {
      this.formatted = [];

      for (const template of result) {
        let field: RegExpExecArray;
        let line = template;

        while (field = match.exec(template)) {
          if (field[1] in this.address) {
            const value = this.address[field[1]] || '';
            line = line.replace(field[0], value).trim();
          } else {
            line = line.replace(field[0], '').trim();
          }
        }

        if (line && line !== template) {
          this.formatted.push(line);
        }
      }
    });
  }

}
